<template>
  <div id="app" class="my-1 container">
    <vue-title title="Tospaa Code Challenge - Multiplayer Coding Game"></vue-title>
    <router-view />

    <div id="menuArea">
      <input type="checkbox" id="menuToggle" />

      <label for="menuToggle" class="menuOpen">
        <div class="open"></div>
      </label>

      <div class="menu menuEffects">
        <label for="menuToggle"></label>
        <div class="menuContent">
          <ul>
            <li><a href="/">Play</a></li>
            <!-- <li><a>Settings</a></li> -->
            <li>
              <a v-on:click="openTutorialModal">How to Play</a>
            </li>
            <li><a v-on:click="openAboutModal">About The Game</a></li>
            <li><a href = "https://tospaa.org/en/cookie-policy/" target="_blank"> Cookie Policy</a> </li> 
            <li><a href = "https://tospaa.org/en/privacy-policy/" target="_blank"> Privacy Policy</a> </li> 
          </ul>
        </div>
      </div>
    </div>

    <div v-if="showTutorial">
      <transition name="modal">
        <div class="modal-mask" data-backdrop="false" data-keyboard="true">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-xl" role="dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" v-on:click="closeTutorialModal"
                      >&times;</span
                    >
                  </button>
                </div>
                <div class="modal-body">
                  <vue-plyr :options="options">
                    <video>
                      <source
                        src="@/assets/videos/tutorial1.mp4"
                        type="video/mp4"
                      />
                    </video>
                    <!--
                    <track
                      default
                      kind="captions"
                      label="English captions"
                      src="/path/to/english.vtt"
                      srclang="en"
                    />
                    -->
                  </vue-plyr>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="aboutGame">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" v-on:click="closeAboutModal"
                      >&times;</span
                    >
                  </button>
                </div>
                <div class="modal-body">
                  <div
                    class="col-12 p-3 justify-content-center"
                    style="text-align: center"
                  >
                    <p style="font-size: 28px; font-weight: bold">
                      About Tospaa
                    </p>
                    <br />
                    Tospaa Unplugged Coding Game, is a screenless coding game
                    designed for early coding education. <br />
                    So far, thousands of schools across Turkey played by
                    hundreds of thousands of children.<br />
                    This is multiplayer versiyon of tospaa. You can download
                    free unplugged version from
                    <a
                      href="https://tospaa.org/en/free-unplugged-coding-game-for-kids/"
                      >this link.</a
                    ><br />
                    Game developed by gamefab team
                    <a href="https://www.gamefab.co/">gamefab.co</a> <br />
                    Graphics by Barbaros DEMIRTAS <a href = https://tr.linkedin.com/in/barbaros-demirta%C5%9F-4b918b10>Linkedin</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

  <footer>
    <cookie-law theme="dark-lime">
      <div slot="message">
        This website uses cookies to ensure you get the best experience on our website. For more information 
        <a href = "https://tospaa.org/en/cookie-policy/" target="_blank"> click here!</a>
      </div>
    </cookie-law>
  </footer>

  </div>
</template>

<style lang="scss">
@import "./assets/styles/gameapp.css";
</style>

<script>
import CookieLaw from "vue-cookie-law";

export default {
  data() {
    return {
      aboutGame: false,
      showTutorial: false,
    };
  },

  components: { CookieLaw },

  methods: {
    closeTutorialModal: function () {
      this.showTutorial = false;
    },

    openTutorialModal: function () {
      this.showTutorial = true;
    },

    closeAboutModal: function () {
      this.aboutGame = false;
    },

    openAboutModal: function () {
      this.aboutGame = true;
    },
  },
};
</script>